import { render, staticRenderFns } from "./orderAlert.vue?vue&type=template&id=efe32e70&scoped=true"
import script from "./orderAlert.vue?vue&type=script&lang=js"
export * from "./orderAlert.vue?vue&type=script&lang=js"
import style0 from "./orderAlert.vue?vue&type=style&index=0&id=efe32e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe32e70",
  null
  
)

export default component.exports